/** General constants */
export default class Constants {
  public static UNKNOWN_EVENT_STATUS = "Unknown";

  public static DECIMAL_PATTERN = /^[0-9]+(\.[0-9]{1,2})?$/;
  public static INTEGER_PATTERN = /^[0-9]+$/;

  public static ROUTE_DATA_ANIMATION_PROP = "animation";

  /**
   * FAM codes whose customer data has moved from Indysoft to Salesforce, mapped to the service email
   * external users are referred to. External users of these customers are blocked.
   */
  public static SALESFORCE_MIGRATED_FAM_CONTACT_EMAILS: Readonly<Record<string, string>> = {
    FNE: "ukservice@desouttertools.com",
  };
}
